import React from 'react';
// import { pathname } from '../../utils/path';
// import { useHistory } from 'react-router';

export default function Welcome() {
  // const history = useHistory();

  return <></>;
}
